import { gql } from "@apollo/client";
export default gql`
  mutation UnsubscribeDiabeticPatient($firstname: String!, $lastname: String!, $medicare: String!, $dob: String!) {
    unsubscribeDiabeticPatient(firstname: $firstname, lastname: $lastname, medicare: $medicare, dob: $dob)
  }
`;
